<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="구(Clause)를 조합하여 문장을 완성합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="ww-jumbotron-content-sentence lg:p-6 p-4 mb-6 rounded-lg text-center text-primary font-bold mb-3">
        {{ content.translation }}
      </div>   

      <!-- <div class="ww-jumbotron-content-sentence lg:p-6 p-4 mb-6 rounded-lg text-center text-primary font-bold mb-3">
        {{ sentence }}
      </div>   -->

      <div v-show="!recordingStep" class="ww-jumbotron-content-sentence lg:p-6 p-4 mb-6 rounded-lg text-center">
        <vs-alert color="primary" :active="!recordingStep" class="mb-3">
            아래에 끌어다 놓으세요.
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col w-full">
              <div class="lg:p-3 p-2 mb-3 rounded-lg text-center text-primary font-bold">{{ sentence }}</div>
              <draggable style="min-height: 60px" v-if="!hint" :list="dropList" group="words" class="cursor-move" @change="checkDrop">
                  <vs-chip class="chip-font" color="primary" v-for="(listItem, index) in dropList" :key="index">{{ listItem.value }}</vs-chip>
              </draggable>
          </div>
        </div>
        
        <vs-divider class="m-1" />

        <div class="vx-row mt-12">
          <!-- <div class="ww-jumbotron-content-translation lg:p-6 p-4 rounded-lg text-center"> -->
            <div class="vx-col w-full flex items-center justify-center">
                <draggable style="min-height: 80px" :list="dragList" group="words" class="cursor-move">
                  <vs-chip class="chip-font" color="success" v-for="(listItem, index) in dragList" :key="index">{{ listItem.trans }}</vs-chip>
                </draggable>
            </div>
          <!-- </div> -->
        </div>  
      </div>

      <div style="min-height: 250px" v-show="recordingStep" class="ww-jumbotron-content-sentence lg:p-6 p-4 mb-6 rounded-lg text-center">
        <vs-alert color="primary" :active="recordingStep" class="mb-3">
            녹음 버튼을 누른 상태에서 녹음을 진행합니다. 녹음이 끝나면 버튼을 놓으세요.
        </vs-alert>
        <div class="vx-row">
          
          <div class="vx-col w-full">
              <div class="lg:p-3 p-2 mb-3 rounded-lg text-center text-primary font-bold">{{ sentence }}</div>
              
              <div class="text-center mt-3">
                <vue-record-audio v-show="!recordingFinished"  :mode="recordMode.audio" @result="onResult" />
                <div v-show="recordingFinished" class="text-center mt-3">
                  <audio ref="userAudioPlayer" controls v-on:ended="userAudioFinish"  />
                </div>
              </div>
          </div>
        </div>
      </div>

      <div class="text-center" >
        <audio ref="audioPlayer" 
            v-on:ended="audioFinish" 
            hidden
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar from './TopButtonBar.vue'
import draggable from 'vuedraggable'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    draggable
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      hint: false,
      dragList: [],
      dropList: [],
      exampleDictation: '',
      exampleTranslation: '',
      finished: false,
      recordMode: {
        audio: 'hold',
        video: 'press'
      },
      recording: '',
      recordingStep: false,
      recordingFinished: false
    }
  },
  watch: {
    sourceContent () {
      this.contentList = []
      this.parseContent()
      this.onReload()
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    userAudioPlayer () {
      return this.$refs.userAudioPlayer
    },
    sentence () {
      if (this.finished) {
        return this.content.sentence
      } else {
        return this.exampleDictation
      } 
    }
  },
  methods: {
    onReload () {
      this.contentIndex = 0
      this.dragList = []
      this.dropList = []
      this.hint = false
      this.finished = false
      this.recordingFinished = false
      this.recordingStep = false
      this.startAlert()
    },
    onResult (data) {
      
      this.recording = window.URL.createObjectURL(data)
      this.recordingFinished = true
      this.userAudioPlayer.src = this.recording
      setTimeout(function () {
        this.userAudioPlayer.play()
      }.bind(this), 1000)
      
    },
    userAudioFinish () {

      if (this.contentIndex >= this.contentsLen - 1) {
        this.onComplete()
      } else {
        this.finished = false
        this.dropList = []
        this.hint = false
        this.recordingStep = false
        this.recordingFinished = false
        this.contentIndex++
        this.dragList = this.getMixedDragList()
      }
    },
    onStart () {
      this.dragList = this.getMixedDragList()
    },
    getMixedDragList () {
      const example = this.content.example.slice()
      const dragList = []
      for (let i = 0; i < example.length; i++) {
        dragList.push({value: example[i], trans: example[i].toLowerCase()})
      }

      let j = 0, x = 0, i = 0
      for (i = dragList.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1))
        x = dragList[i]
        dragList[i] = dragList[j]
        dragList[j] = x
      }
      return dragList
    },
    startAlert () {
      this.startStudyDlg('구(Clause)를 조합하여 문장을 완성합니다.')
    },
    audioFinish () {
      // 녹음을 시작한다.
      this.recordingStep = true
    },
    acceptAlert () {
      this.onStart()
    },
    checkDrop () {
      
      if (this.dropList.length === 0) return
      if (this.dropList[0].value === this.content.answer) {
        
        this.finished = true
        this.correct()

        this.audioPlayer.src = this.content.audio
        this.audioPlayer.play()
      } else {
        
        this.inCorrect()

        this.dropList = []
        this.dragList = this.getMixedDragList()
      }
    },
    onHint () {
      this.hint = true
      setTimeout(function () {
        this.hint = false
      }.bind(this), 2000)
    },
    parseContent () {
      const contentJson = JSON.parse(this.sourceContent.contentBody)
      this.exampleDictation = contentJson.exampleDictation[0]
      this.exampleTranslation = contentJson.exampleTranslation[0]

      for (let i = 0; i < contentJson.sentence.length; i++) {
        const content = {
          sentence: contentJson.sentence[i],
          translation: contentJson.translation[i],
          answer: contentJson.answer[i],
          example: contentJson.answer,  // 전체 answer를 example로 사용한다.
          audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
        } 
        this.contentList.push(content)
      }
      this.contentsLen = this.contentList.length
    }
  },
  created () {
    this.parseContent()
    this.startAlert()
  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
.chip-font {
  font-size: 18px
}
</style>